import type { AuthProvider } from '@entities/auth'

const STORAGE_KEY = 'saju-last-provider'

export function getLastProvider(): AuthProvider | null {
  const value = localStorage.getItem(STORAGE_KEY)
  if (value === 'KAKAO' || value === 'GOOGLE') {
    return value
  }
  return null
}

export function setLastProvider(provider: AuthProvider): void {
  localStorage.setItem(STORAGE_KEY, provider)
}

export function removeLastProvider(): void {
  localStorage.removeItem(STORAGE_KEY)
}
